import type { Editor } from '@tiptap/react';
import type { IconType } from 'react-icons';

import { FiBold, FiCode, FiItalic, FiMinus } from 'react-icons/fi';

export interface MarkdownHighlightCommand {
  id: string;
  label: string;
  icon: IconType;
  run: () => void;
}

export function createMarkdownHighlightCommands(
  editor: Editor,
): MarkdownHighlightCommand[] {
  const commands = [
    {
      id: 'bold',
      label: 'Bold',
      icon: FiBold,
      run: () => editor.chain().focus().toggleBold().run(),
    },
    {
      id: 'italic',
      label: 'Italic',
      icon: FiItalic,
      run: () => editor.chain().focus().toggleItalic().run(),
    },
    {
      id: 'strike',
      label: 'Strike',
      icon: FiMinus,
      run: () => editor.chain().focus().toggleStrike().run(),
    },
    {
      id: 'inline-code',
      label: 'Inline code',
      icon: FiCode,
      run: () => editor.chain().focus().toggleCode().run(),
    },
  ] satisfies MarkdownHighlightCommand[];

  return commands;
}
